/* FILTHYBASS header navigation behaviour.
   <fb-nav-item>   one bar item (SHOP, FACES, HELP) with its panel: hover intent, click, keyboard.
   <fb-nav-drawer> the phone menu: a sheet from the left with a focus trap.
   Spec: docs/superpowers/specs/2026-10-14-nav-and-discovery-design.md */
(function () {
  if (customElements.get('fb-nav-item')) return;

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var openItem = null;
  var backdrop = null;

  function getBackdrop() {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'fb-nav-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('click', function () {
        if (openItem) openItem.close();
      });
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) {
      var item = openItem;
      item.close();
      if (item.toggle) item.toggle.focus();
    }
  });

  class FbNavItem extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-fb-toggle]');
      this.panel = this.querySelector('[data-fb-panel]');
      if (!this.toggle || !this.panel) return;
      this.openDelay = Number(this.closest('[data-open-delay]')?.dataset.openDelay || 300);
      this.closeDelay = Number(this.closest('[data-close-delay]')?.dataset.closeDelay || 300);
      this.header = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
      this.timer = null;

      this.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch') return;
        this.warm();
        this.schedule(true);
      });
      this.toggle.addEventListener('focus', () => this.warm());
      this.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'touch') return;
        this.schedule(false);
      });
      this.toggle.addEventListener('click', () => {
        clearTimeout(this.timer);
        this.isOpen() ? this.close() : this.open();
      });
      this.addEventListener('focusout', () => {
        setTimeout(() => {
          if (this.isOpen() && !this.contains(document.activeElement)) this.close();
        });
      });
      this.lineup = this.panel.querySelector('[data-fb-lineup]');
      if (this.lineup) this.setUpLineup();
    }

    isOpen() {
      return !this.panel.hidden;
    }

    /* Start the panel's photos while the hover delay runs, so they are there when it opens.
       Face previews other than the first wait until their face is pointed at. */
    warm(scope) {
      var root = scope || this.panel;
      root.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        var preview = img.closest('[data-fb-preview]');
        if (!scope && preview && preview !== this.panel.querySelector('[data-fb-preview]')) return;
        img.loading = 'eager';
      });
    }

    schedule(wantOpen) {
      clearTimeout(this.timer);
      if (wantOpen === this.isOpen()) return;
      this.timer = setTimeout(() => (wantOpen ? this.open() : this.close()), wantOpen ? this.openDelay : this.closeDelay);
    }

    open() {
      clearTimeout(this.timer);
      if (openItem && openItem !== this) openItem.close(true);
      if (this.header) {
        this.header.preventHide = true;
        document.documentElement.style.setProperty(
          '--fb-header-bottom',
          Math.floor(this.header.getBoundingClientRect().bottom) + 'px'
        );
      }
      this.panel.hidden = false;
      if (!reduceMotion) {
        this.panel.classList.remove('is-entering');
        void this.panel.offsetWidth;
        this.panel.classList.add('is-entering');
      }
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      openItem = this;
      getBackdrop().classList.add('is-on');
      if (this.lineup && !this.lineup.querySelector('.fb-face.is-active')) {
        var first = this.lineup.querySelector('[data-fb-face]');
        if (first) this.activateFace(first);
      }
      this.dispatchEvent(new CustomEvent('fb-nav:open', { bubbles: true }));
    }

    close(switching) {
      clearTimeout(this.timer);
      this.panel.hidden = true;
      this.panel.classList.remove('is-entering');
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      if (openItem === this) openItem = null;
      if (!switching) {
        getBackdrop().classList.remove('is-on');
        if (this.header) this.header.preventHide = false;
      }
    }

    /* ---- FACES: hovering a face shows its products. Moving the pointer from a face
       toward its products must not switch to the faces it crosses on the way (menu aim). ---- */
    setUpLineup() {
      this.stage = this.lineup.querySelector('[data-fb-stage]');
      this.track = [];
      this.pending = null;
      this.lineup.addEventListener('pointermove', (e) => {
        this.track.push({ x: e.clientX, y: e.clientY });
        if (this.track.length > 4) this.track.shift();
      });
      this.lineup.querySelectorAll('[data-fb-face]').forEach((face) => {
        face.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'touch') return;
          var preview = this.lineup.querySelector('[data-fb-preview="' + face.dataset.fbFace + '"]');
          if (preview) this.warm(preview);
          this.aimAt(face);
        });
        face.addEventListener('focus', () => this.activateFace(face));
      });
    }

    aimAt(face) {
      clearTimeout(this.pending);
      if (this.isAimingAtStage()) {
        this.pending = setTimeout(() => this.aimAt(face), 120);
        return;
      }
      if (face.matches(':hover')) this.activateFace(face);
    }

    isAimingAtStage() {
      if (!this.stage || this.track.length < 2) return false;
      var now = this.track[this.track.length - 1];
      var before = this.track[0];
      var r = this.stage.getBoundingClientRect();
      if (now.x >= r.left || now.x <= before.x) return false;
      var slope = (a, b) => (b.y - a.y) / (b.x - a.x);
      var top = { x: r.left, y: r.top - 40 };
      var bottom = { x: r.left, y: r.bottom + 40 };
      return slope(now, top) < slope(before, top) && slope(now, bottom) > slope(before, bottom);
    }

    activateFace(face) {
      var key = face.dataset.fbFace;
      this.lineup.querySelectorAll('[data-fb-face]').forEach((f) => {
        var on = f === face;
        f.classList.toggle('is-active', on);
        if (on) f.setAttribute('aria-current', 'true');
        else f.removeAttribute('aria-current');
      });
      this.lineup.querySelectorAll('[data-fb-preview]').forEach((p) => {
        p.hidden = p.dataset.fbPreview !== key;
      });
    }
  }
  customElements.define('fb-nav-item', FbNavItem);

  class FbNavDrawer extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-fb-drawer-toggle]');
      this.drawer = this.querySelector('[data-fb-drawer]');
      if (!this.toggle || !this.drawer) return;
      this.sheet = this.drawer.querySelector('[role="dialog"]');
      this.toggle.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
      this.drawer.querySelectorAll('[data-fb-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.drawer.addEventListener('keydown', (e) => this.onKey(e));
    }

    isOpen() {
      return this.drawer.classList.contains('is-open');
    }

    open() {
      this.drawer.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('fb-drawer-lock');
      var close = this.drawer.querySelector('.fb-drawer__close');
      setTimeout(() => close && close.focus(), reduceMotion ? 0 : 60);
    }

    close() {
      this.drawer.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('fb-drawer-lock');
      this.toggle.focus();
    }

    onKey(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = Array.from(
        this.sheet.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
  customElements.define('fb-nav-drawer', FbNavDrawer);
})();
